import {AfterViewInit,ChangeDetectionStrategy, Component,  ElementRef, OnDestroy, Input, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription} from "rxjs";
import {ActivatedRoute, Params} from '@angular/router';
//import {MaterialInstance, MaterialService} from "../../../classes/material.service";
import {StreamsService}  from "../../../services/streams.service";
import {StreamProject} from "../../../interfaces";
import {switchMap, map, delay} from 'rxjs/operators'; 
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
import * as moment from 'moment';

@Component({
  selector: 'app-stream-countdown',
  templateUrl: './stream-countdown.component.html', 

  styleUrls: ['./stream-countdown.component.scss'],
})
export class StreamCountdownComponent implements OnInit, OnDestroy{
  

  @Input() stream: StreamProject;
  @ViewChild('idetInfo') infoEdit:any ;
  
  infoForm: FormGroup
  dateAndTime:any = {
    date: new Date(),
    time: ''
  }

   constructor(public streamsService:StreamsService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
    ){
}
 


  ngOnInit() {
    this.infoForm = new FormGroup({
      title: new FormControl(this.stream.title, [Validators.required]),
      description: new FormControl(this.stream.description)
    })


    //console.log()
  }



openEdit(){
	 
   
  this.dialogService.open(this.infoEdit,{hasScroll: true} )

}

openModal(content) {
  this.infoForm.patchValue({
    title: this.stream.title,
    description: this.stream.description

  }) 

  this.dialogService.open(content,{hasScroll: true} )

	
}




openDateModal(content) {
     
  if(this.stream.show_date  ){
  this.dateAndTime.date = new Date(this.stream.show_date)
  
  this.dateAndTime.time = moment(this.dateAndTime.date).format('HH:mm')
 
  } else {
    this.dateAndTime.date = new Date()
    this.dateAndTime.time = ''
  }

  this.dialogService.open(content,{hasScroll: true} ) 
}

saveDateTime(ref,dateInput, timeInput){
    
  var d = ''



  let dateValue = dateInput.value
  let timeValue = timeInput.value

 
  if(!dateValue && !timeValue.replace('__:__','')){
    ref.close()
    this.updateShowDate(0)

    return
  }

  var dateArray = dateValue.split('.')
 
  dateArray = dateArray.reverse()
   for(let i = 0; i< dateArray.length; i++){
     d += dateArray[i]
     if(i < (dateArray.length -1)){
       d += '-'
     }
   }
   let date :any =  false
   try{
    date = moment(d + 'T' + timeValue+':00').unix() 

   }catch(error){

   }

   if(!date) {
    this.toastrService.show('','Неправильний формат дати і часу',{
      status: 'danger',
    	position: <NbGlobalPosition>'bottom-right'
    })
    return
   }
   ref.close()

   date = date * 1000
   
  this.dateAndTime.date =  Date.parse(date)
  this.dateAndTime.time = timeValue
  //this.stream.show_date = date
  this.updateShowDate(date)
}


 
updateShowDate$: any = null
updateShowDate(date){
  //console.log(fileInput.files.clear())

 
  this.updateShowDate$ = this.streamsService.updateShowDate(this.stream._id, date).subscribe(
    stream=>{
      
     
     this.stream.show_date = stream.show_date
 
	let message = 'Дата початку трансляції встановлена'
     
	 if(!this.stream.show_date){ 
	  message = 'Дата початку трансляції скинута'

	}
            this.toastrService.show('',message,{
	       status: 'success',
	       position: <NbGlobalPosition>'bottom-right'
	     })

   },error =>{ 
    // MaterialService.toast(error.error.message)
     this.toastrService.show('Сталася помилка','Не вдалося встановити дату початку трансляції',{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-right'
    })
   } 
 )

}


 



 
  
  ngOnDestroy() { 
    if(this.updateShowDate$){
      this.updateShowDate$.unsubscribe()
    } 


   }
  
}
